import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import { getEventAnchorFromContextMap } from 'automation-ui-action-features/actions/classic-anchored-delay/utils/getEventAnchorFromContextMap';
import ClassicAnchoredDelayActionDetail from 'automation-ui-action-features/actions/classic-anchored-delay/ClassicAnchoredDelayActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
const ClassicAnchoredDelayActionHistoryCard = ({
  actionMetadata,
  contextMap = {},
  actionLabel
}) => {
  const eventAnchor = getEventAnchorFromContextMap({
    contextMap
  });
  return /*#__PURE__*/_jsx(LogEventRowAction, {
    title: actionLabel,
    content: /*#__PURE__*/_jsx(ClassicAnchoredDelayActionDetail, {
      actionMetadata: actionMetadata,
      eventAnchor: eventAnchor,
      recurAnnually: false
    })
  });
};
export default ClassicAnchoredDelayActionHistoryCard;